import { postRequest1, postRequest2 } from "../../api/login/index.js";
/* eslint-disable react-hooks/exhaustive-deps */
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Box, Button, CircularProgress, IconButton, Skeleton, TextField } from "@mui/material";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { baseUrl, DOWNLOAD_FILE } from "../../../../shared/api/endpoints.js";


import { login } from "../../../../shared/state/slices/user.js";
const Login = () => {
  const [passWord, setpassWord] = useState("");
  const [mobile, setMobile] = useState("");
  const [code, setCode] = useState("");
  const [seePassword, setseePassword] = useState(false);
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.user);
  const [state, setState] = useState(1);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { companyInfo } = useSelector((state) => state.relationals);
  /*   useEffect(() => {
      axios(`${baseUrl}/${getStaticsData}`)
        .then((res) => {
          const { data } = res;
          dispatch(setCompanyInfo(data?.data?.company));
        })
        .catch((err) => {});
    }, []); */
  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token]);

  const SendCode = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      email: mobile,
      password: passWord,
    };
    postRequest1(data)
      .then((res) => {
        dispatch(login(res.data));
        setLoading(false);

      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
        setLoading(false);
      });
  };
  const LoginRequest = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      mobile: mobile,
      code,
    };
    postRequest2(data)
      .then((res) => {
        setLoading(false);
        navigate("/");
        dispatch(login(res.data));
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
        setLoading(false);
      });
  };
  return (
    <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12 login">
      <div className="relative py-3 sm:max-w-xl sm:mx-auto">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-300 to-blue-600 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
        <div className="relative md:px-3 px-[1.2rem] mx-[1.2rem] py-10 bg-white shadow-lg sm:rounded-3xl sm:p-10 md:min-w-[400px] md:mx-2 rounded-2xl sm:mx-0">
          {state === 1 ? (
            <Box
              sx={{ opacity: state === 1 ? 1 : 0 }}
              className="max-w-md mx-auto transition-all"
            >
              <div className="flex justify-between items-center">
                <h1 className="text-base font-semibold">ورود به پنل مدیریت</h1>
                <a
                  href="https://panel.digikraam.nl/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {companyInfo?.companyLogo ? (
                    <img
                      src={`${baseUrl}/${DOWNLOAD_FILE}/${companyInfo?.companyLogo}`}
                      alt="logo"
                      width={120}
                    /*    height={120} */
                    />
                  ) : (
                    <>
                      <Skeleton width={70} height={60} />
                    </>
                  )}
                </a>
              </div>
              <div className="divide-y divide-gray-200">
                <form
                  onSubmit={SendCode}
                  className="py-8 text-base leftInput leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7"
                >
                  <TextField
                    onChange={(e) => setMobile(e.target.value)}
                    variant="standard"
                    label=" ایمیل"
                    fullWidth
                    autoFocus
                    value={mobile}
                    type="email"
                  />
                  <Box sx={{ position: "relative" }} className="relative">
                    <TextField
                      type={seePassword ? "text" : "password"}
                      variant="standard"
                      onChange={(e) => setpassWord(e.target.value)}
                      label=" رمز عبور"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={passWord}
                    />
                    <IconButton
                      sx={{
                        position: "absolute",
                        top: "1.6rem",
                        left: "10px",
                      }}
                      onClick={() => setseePassword(!seePassword)}
                    >
                      {seePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </Box>

                  <div className="flex justify-end">
                    <Button
                      sx={{ width: "120px", height: "40px" }}
                      disabled={loading}
                      type="submit"
                      variant="contained"
                    >
                      {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
                    </Button>
                  </div>
                </form>
              </div>
            </Box>
          ) : (
            <Box
              sx={{ opacity: state === 2 ? 1 : 0 }}
              className="max-w-md mx-auto transition-all sm:min-w-[352px]"
            >
              <div className="flex justify-between items-center">
                <h1 className="text-base font-semibold">
                  کد ارسالی را وارد کنید
                </h1>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setState(1);
                  }}
                >
                  بازگشت
                </Button>
              </div>
              <form
                onSubmit={LoginRequest}
                className="divide-y divide-gray-200"
              >
                <div className="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                  <TextField
                    onChange={(e) => setCode(e.target.value)}
                    variant="standard"
                    label=" کد ارسالی"
                    fullWidth
                    value={code}
                    type="tel"
                  />

                  <div className="flex justify-end">
                    <Button
                      sx={{ width: "120px", height: "40px" }}
                      disabled={loading}
                      type="submit"
                      variant="contained"
                    >
                      {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
                    </Button>
                  </div>
                </div>
              </form>
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
